//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mfg.AM.js";
import "../no/TransientObject.js";
let d=[[],[[[],"GetNestedLength",{R_:{nestingLength:''}},0,0],[[],"GetNestedWidth",{R_:{nestingWidth:''}},0,0],[[],"GetNestedHeight",{R_:{nestingHeight:''}},0,0],[[],"GetDensity",{R_:{density:''}},0,0],[["num_parts"],"GetNestedParts",{R_:{tagPart:"Mfg.AM.Part[]"}},0,0],[["num_parts"],"GetNotNestedParts",{R_:{tagPart:"Mfg.AM.Part[]"}},0,0],[[],"GetErrorCode",{R_:{errorCode:''}},0,0],[[],"Dispose",{},0,0]],[]];
SPLM.Mfg.AM.NestingStatus = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mfg.AM.NestingStatus";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;